import { ValidationErrors, ValidatorFn } from '@angular/forms';

const PermanentlyInvalidValidator = (reason: string): ValidatorFn => {
	return (): ValidationErrors | null => {
		return { [reason]: true };
	};
};

export { PermanentlyInvalidValidator };
